'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptsToValue = exports.SIDEBAR_OPTION = undefined;

var _OptsToPath, _OptsToValue;

var _AllowedCustomOpts = require('./AllowedCustomOpts');

var _AllowedCustomOpts2 = _interopRequireDefault(_AllowedCustomOpts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIDEBAR_OPTION = exports.SIDEBAR_OPTION = 'opt_sidebar';
var SALES_EXTENSION_OPTION = 'sales-extension-signup';
var LIVECHAT_OPTION = 'livechat-signup';
var MEETING_OPTION = 'meeting';
var LEADFLOWS_OPTION = 'leadflows';
var FORMS_OPTION = 'forms';
var DOCUMENTS_OPTION = 'documents';

var OptsToPath = (_OptsToPath = {}, _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.MEETING_SIDEBAR, SIDEBAR_OPTION), _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.SALES_EXTENSION_SIDEBAR, SIDEBAR_OPTION), _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.LIVECHAT_SIDEBAR, SIDEBAR_OPTION), _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.LEADFLOWS_SIDEBAR, SIDEBAR_OPTION), _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.FORMS_SIDEBAR, SIDEBAR_OPTION), _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.DOCUMENTS_SIDEBAR, SIDEBAR_OPTION), _OptsToPath);

var OptsToValue = exports.OptsToValue = (_OptsToValue = {}, _defineProperty(_OptsToValue, _AllowedCustomOpts2.default.MEETING_SIDEBAR, MEETING_OPTION), _defineProperty(_OptsToValue, _AllowedCustomOpts2.default.SALES_EXTENSION_SIDEBAR, SALES_EXTENSION_OPTION), _defineProperty(_OptsToValue, _AllowedCustomOpts2.default.LIVECHAT_SIDEBAR, LIVECHAT_OPTION), _defineProperty(_OptsToValue, _AllowedCustomOpts2.default.LEADFLOWS_SIDEBAR, LEADFLOWS_OPTION), _defineProperty(_OptsToValue, _AllowedCustomOpts2.default.FORMS_SIDEBAR, FORMS_OPTION), _defineProperty(_OptsToValue, _AllowedCustomOpts2.default.DOCUMENTS_SIDEBAR, DOCUMENTS_OPTION), _OptsToValue);

exports.default = OptsToPath;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.35/js/constants/OptsToPath.js
// module id = 1064
// module chunks = 2 3